import { api } from "../services/api";
import { createReduxModule } from "hooks-for-redux";
// import { userStore } from "./user";
import { ChessSets } from "@chesshotel/constants";
import { getSize } from "../util/boardSize";

const initialState = {
  sound: true,
  autoQueening: false,
  minOpponentRating: 0,
  maxOpponentRating: 4000,
  activePage: 0,
  noGuests: false,
  pieceDestinations: true,
  lastMove: true,
  chessSet: ChessSets.CHESSHOTEL,
  boardSize: null,
  isDesktop: null,
  height: null,
};

export const [
  useSettings,
  { setSetting, doSetSettings, doSetBoardSize, reset },
  settingsStore,
] = createReduxModule("settings", initialState, {
  setSetting: (state, { name, val }) => ({
    ...state,
    [name]: val,
  }),
  doSetSettings: (state, settings) => ({
    ...state,
    ...settings,
  }),
  doSetBoardSize: (state, { boardSize, isDesktop, height }) => ({
    ...state,
    boardSize,
    isDesktop,
    height,
  }),
  reset: (state) => ({
    ...initialState,
    boardSize: state.boardSize,
    isDesktop: state.isDesktop,
    height: state.height,
  }),
});

// export function initChessSetSettings() {
//   const chessSet = localStorage.getItem("chessSet");
//   if (chessSet) {
//     setSetting({ name: "chessSet", val: chessSet });
//   }
// }

export function setBoardSize() {
  const { boardSize, isDesktop, height } = settingsStore.getState();

  function updateChessboardSize() {
    const size = getSize();

    if (
      size.boardSize !== boardSize ||
      size.isDesktop !== isDesktop ||
      size.height !== height
    ) {
      doSetBoardSize({
        boardSize: size.boardSize,
        isDesktop: size.isDesktop,
        height: size.height,
      });
    }
  }

  // Initialize immediately if not set
  if (boardSize === null || isDesktop === null) {
    updateChessboardSize();
  }

  // Add listeners for future updates
  window.addEventListener("resize", updateChessboardSize);
  window.addEventListener("orientationchange", updateChessboardSize);
}

export function setSettings(settingsArr) {
  const settings: any = {};
  settingsArr.forEach((item) => {
    settings[item.name] = item.value;
  });

  const settingsState = settingsStore.getState();

  const sound = settings.sound ? settings.sound === "true" : true;
  const autoQueening = settings.autoQueening
    ? settings.autoQueening === "true"
    : false;
  // const time = settings.time ? parseInt(settings.time) : 10;
  // const inc = settings.inc ? parseInt(settings.inc) : 0;
  // const variant = settings.variant ? parseInt(settings.variant) : VARIANT_CHESS;

  const minOpponentRating = settings.minOpponentRating
    ? parseInt(settings.minOpponentRating)
    : 0;
  const maxOpponentRating = settings.maxOpponentRating
    ? parseInt(settings.maxOpponentRating)
    : 4000;
  const noGuests = settings.noGuests ? settings.noGuests === "true" : false;

  const pieceDestinations = settings.pieceDestinations
    ? settings.pieceDestinations === "true"
    : settingsState.pieceDestinations;
  const lastMove = settings.lastMove
    ? settings.lastMove === "true"
    : settingsState.lastMove;

  const chessSet = settings.chessSet || ChessSets.CHESSHOTEL;

  doSetSettings({
    sound,
    autoQueening,
    // time,
    // inc,
    // variant,
    minOpponentRating,
    maxOpponentRating,
    noGuests,
    pieceDestinations,
    lastMove,
    chessSet,
  });
}

export function updateSetting(name, val) {
  import("./user").then(({ userStore }) => {
    const { memberLoggedIn } = userStore.getState();
    if (memberLoggedIn && val != null) {
      const value = val.toString();
      localStorage.setItem(name, value);
      api.post("/setting/update", { name, value }).catch(() => {
        console.log("error in function updateSetting");
      });
    }
    setSetting({ name, val });
  });
}
